import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { Box, Container } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import './Home.css';
import { useThemeMode } from '../context/ThemeContext';
import Hero from '../components/home/sections/Hero';
import WhySacem from '../components/home/sections/WhySacem';
import RoyaltiesEstimator from '../components/home/sections/RoyaltiesEstimator';
import HowItWorks from '../components/home/sections/HowItWorks';
import Benefits from '../components/home/sections/Benefits';
import ForArtists from '../components/home/sections/ForArtists';
import Pricing from '../components/home/sections/Pricing';
import Faq from '../components/home/sections/Faq';
import CtaBanner from '../components/home/sections/CtaBanner';
import HomeFooter from '../components/home/sections/HomeFooter';

export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  // Subscribe to theme so Home re-renders when the user toggles light/dark.
  const { colors } = useThemeMode();

  useEffect(() => {
    if (user) navigate('/dashboard');
  }, [user, navigate]);

  useEffect(() => {
    if (!location.hash) return;
    const sectionId = location.hash.replace('#', '');
    const scrollTarget = () => {
      const node = document.getElementById(sectionId);
      if (!node) return;
      node.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    const timeoutId = window.setTimeout(scrollTarget, 80);
    return () => window.clearTimeout(timeoutId);
  }, [location.hash]);

  const scrollToSection = useCallback((id) => {
    const node = document.getElementById(id);
    if (!node) return;
    node.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  return (
    <Box sx={{ bgcolor: colors.bgDefault, minHeight: '100vh', pt: 8, position: 'relative', overflow: 'hidden' }}>
      {/* Gradient mesh background */}
      <Box aria-hidden sx={{
        position: 'absolute', inset: 0, height: 1100, pointerEvents: 'none', zIndex: 0,
        background: `
          radial-gradient(40% 32% at 18% 12%, ${colors.info}29, transparent 70%),
          radial-gradient(38% 30% at 82% 8%, ${colors.secondary}29, transparent 70%),
          radial-gradient(45% 38% at 50% 42%, ${colors.primaryLight}24, transparent 70%)`,
      }} />

      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Hero colors={colors} user={user} navigate={navigate} />
        <WhySacem colors={colors} />
        <RoyaltiesEstimator colors={colors} user={user} navigate={navigate} />
        <HowItWorks colors={colors} />
        <Benefits colors={colors} />
        <ForArtists colors={colors} />
        <Pricing colors={colors} user={user} scrollToSection={scrollToSection} />
        <Faq colors={colors} />
        <CtaBanner colors={colors} user={user} navigate={navigate} />
      </Container>

      <HomeFooter colors={colors} navigate={navigate} scrollToSection={scrollToSection} />
    </Box>
  );
}
